import React, { useMemo } from "react";

import styles from "./style.module.scss";
import { ReducedOrder, ReducedShippingInfo } from "../../generated/graphql";
import { LocalisedText, useI18n } from "../../i18n";

interface PaymmentSubmissionSuccessProps {
  order: ReducedOrder;
  shippingInfo: ReducedShippingInfo;
  paymentType: string;
}

const PaymmentSubmissionSuccess: React.FC<PaymmentSubmissionSuccessProps> = (
  props: PaymmentSubmissionSuccessProps
) => {
  const { paymentType, order, shippingInfo } = props;
  const i18n = useI18n();

  const { channelType, channelInfo } = useMemo(() => {
    switch (order.channelType) {
      case "FACEBOOK":
        return {
          channelType: i18n.translate("channelType.facebook"),
          channelInfo: shippingInfo.name || "",
        };
      case "WHATSAPP":
        return {
          channelType: i18n.translate("channelType.whatsapp"),
          channelInfo: shippingInfo.phone || "",
        };
      case "WHATSAPP2":
        return {
          channelType: i18n.translate("channelType.whatsapp"),
          channelInfo: shippingInfo.phone || "",
        };
      case "EMAIL":
        return {
          channelType: i18n.translate("channelType.email").toLowerCase(),
          channelInfo: shippingInfo.email || "",
        };
      case "SANUKER":
        if (
          order.channelSubType === "FACEBOOK_MESSAGING" ||
          order.channelSubType === "FACEBOOK_FEED"
        ) {
          return {
            channelType: i18n.translate("channelType.facebook"),
            channelInfo: shippingInfo.name || "",
          };
        }
        if (order.channelSubType === "WHATSAPP") {
          return {
            channelType: i18n.translate("channelType.whatsapp"),
            channelInfo: shippingInfo.phone || "",
          };
        }
        return {
          channelType: i18n.translate("channelType.sanuker"),
          channelInfo: shippingInfo.name || "",
        };
      default:
        return {
          channelType: i18n.translate("channelType.unknown"),
          channelInfo: shippingInfo.name || "",
        };
    }
  }, [order.channelType, order.channelSubType, shippingInfo, i18n]);

  return (
    <div className={styles.submissionSuccess}>
      <div className={styles.title}>
        {paymentType === "custom" ? (
          <LocalisedText id="view.paymentSubmissionSuccess.submissionSuccessful" />
        ) : (
          <LocalisedText id="view.paymentSubmissionSuccess.paymentSuccessful" />
        )}
      </div>
      <div className={styles.successLogo} />
      <div className={styles.text}>
        <LocalisedText
          id="view.paymentSubmissionSuccess.processText"
          values={{
            orderId: order.id,
          }}
        />
      </div>
      <div className={styles.text}>
        <LocalisedText
          id="view.paymentSubmissionSuccess.sendToConversationText"
          values={{
            channelType,
            channelInfo,
          }}
        />
      </div>
    </div>
  );
};

export default PaymmentSubmissionSuccess;
